var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-0 pa-1 text-decoration-underline",attrs:{"color":"primary","min-width":"0","text":""},on:{"click":_vm.logout}},[_vm._v(" ログアウト ")])
}
var staticRenderFns = []

export { render, staticRenderFns }